const initialState = { 
  loading: false,
  payload: null,
  error: null
}

function detailCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_VOUCHER_BEGIN':
      return {
        ...state,
        loading: true,
        payload: null,
        error: null
      }

    case 'GET_VOUCHER_SUCCESS':
      return {
        ...state,
        loading: false,
        payload: action.payload
      }

    case 'GET_VOUCHER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default detailCategoryReducer